export default __webpack_public_path__ + "static/media/education-benefit.e6be6483.png";